import React, {Suspense} from "react";
import {useProductListContext} from "../productListProvider/ProductListProvider";
import {ProductListFilterItemBoolean, ProductListFilterItemSelect} from "../../../typescript-library";
import {useTranslation} from "react-i18next";
import ResetFiltersButton from "../../atoms/ResetFiltersButton";
import {RemoveFilterButton} from "../../atoms/RemoveFilterButton";
import {currencyFormatRange, percentFormat, unitFormatRange} from "../../../helpers/intlFormatters";
import ErrorBoundary from "../../utils/ErrorBoundary";

/* Formerly known as 'FilterReview' component */

const SelectedFilterOverviewComp: React.FC = () => {
  const {state, dispatch} = useProductListContext();
  const {t} = useTranslation();
  const {filters, instance} = state;

  const filterValues = instance?.filter.filterItems;
  const filtersEntries = Object.entries(filters).filter(([key]) => !state.defaultFilter?.split("=")[0].includes(key));

  if (!filtersEntries.length || !filterValues) {
    return null;
  }

  const onRemoveSelectFilter = (field: string, value: string) => {
    const filterValue = filters[field] as string[];
    const newFilterValue = filterValue.filter((_value) => _value !== value);
    if (newFilterValue.length) {
      dispatch({
        type: "SET_FILTER",
        payload: {field, value: newFilterValue},
      });
    } else {
      dispatch({type: "REMOVE_FILTER", payload: {field}});
    }

    dispatch({type: "TRIGGER"});
  };

  const onRemoveFilter = (field: string) => {
    dispatch({type: "REMOVE_FILTER", payload: {field}});
  };

  return (
    <div className="filter-remove__wrapper">
      {filtersEntries.map(([key, keyValue]) => {
        if (typeof keyValue === "boolean") {
          if (!keyValue) {
            return null;
          }
          const filterValue = filterValues?.get(key) as ProductListFilterItemBoolean;

          return (
            <RemoveFilterButton
              key={key}
              onCancel={() => {
                onRemoveFilter(key);
              }}
            >
              {filterValue.name || t(`product.${filterValue.field}`)}
            </RemoveFilterButton>
          );
        }

        if (Array.isArray(keyValue)) {
          if (!keyValue.length) {
            return null;
          }
          const filterValue = filterValues?.get(key) as ProductListFilterItemSelect;

          return keyValue.map((value) => {
            return (
              <RemoveFilterButton
                key={value}
                onCancel={() => {
                  onRemoveSelectFilter(key, value);
                }}
              >
                {key === "availability" ? t("product.inStock") : filterValue.rootValues.get(value)?.name}
              </RemoveFilterButton>
            );
          });
        }

        if (typeof keyValue === "object") {
          const limit = state.rangeFilterMap?.get(key);
          if (!limit) {
            return null;
          }

          if (key !== "percentageDiscount" && keyValue.min === limit.min && keyValue.max === limit.max) {
            return null;
          }

          let title;
          switch (key) {
            case "price":
              title = currencyFormatRange(keyValue.min, keyValue.max);
              break;
            case "percentageDiscount":
              title = t("general.lowerLimit--percent", {
                percent: percentFormat(keyValue.min),
              });
              break;
            default:
              title = unitFormatRange(keyValue.min, keyValue.max);
          }

          return (
            <RemoveFilterButton
              key={key}
              onCancel={() => {
                onRemoveFilter(key);
              }}
            >
              {title}
            </RemoveFilterButton>
          );
        }

        return null;
      })}
      <ResetFiltersButton />
    </div>
  );
};

const SelectedFilterOverview: React.FC = () => {
  return (
    <ErrorBoundary fallback={null} occurrence="SelectedFilterOverview">
      <Suspense fallback={null}>
        <SelectedFilterOverviewComp />
      </Suspense>
    </ErrorBoundary>
  );
};

export default SelectedFilterOverview;
